import { render, staticRenderFns } from "./FixedAssetBrowse.vue?vue&type=template&id=9563808a&scoped=true"
import script from "./FixedAssetBrowse.vue?vue&type=script&lang=ts"
export * from "./FixedAssetBrowse.vue?vue&type=script&lang=ts"
import style0 from "./FixedAssetBrowse.vue?vue&type=style&index=0&id=9563808a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9563808a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9563808a')) {
      api.createRecord('9563808a', component.options)
    } else {
      api.reload('9563808a', component.options)
    }
    module.hot.accept("./FixedAssetBrowse.vue?vue&type=template&id=9563808a&scoped=true", function () {
      api.rerender('9563808a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bookkeeping/FixedAssetBrowse.vue"
export default component.exports